/**
 * Premium is ad-free only while the subscription is still active.
 * Missing expiry is treated as active so a just-verified payment still hides ads.
 */
export function isAdFreeUser(user) {
  if (!user?.isPremium) return false;
  if (!user.subscriptionExpiry) return true;
  const expiry = new Date(user.subscriptionExpiry);
  if (Number.isNaN(expiry.getTime())) return true;
  return expiry.getTime() > Date.now();
}
